// Modal Dialog
class ModalDialog1 extends HTMLElement {
  constructor() {
    super();

    // Close button
    this.querySelector('[id^="ModalClose-"]')?.addEventListener(
      "click",
      this.hide.bind(this)
    );

    // Swiper initialization
    this.slider = new Swiper(".realization-slider", {
      slidesPerView: 1,
      effect: "fade",
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    // Close on ESC key
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });

    // Close on background click
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener, index) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");

    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();

    // Find the unique model name for clicked item
    const mName = jQuery(opener).closest(".multicolumn-list__item, .swiper-slide").attr("data-model-name");

    if (mName) {
      // Slide to the exact slide with matching model_name
      const idx = jQuery(`#PopupModal-detail .swiper-slide[model_name="${mName}"]`).index();
      if (idx >= 0) this.slider.slideTo(idx);
    } else {
      // Fallback if no model_name found
      this.slider.slideTo(index - 1);
    }
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

customElements.define("modal-dialog1", ModalDialog1);

// Modal Opener
class ModalOpener1 extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("button");
    if (!button) return;

    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      const modelName = button.getAttribute("data-name");

      // Get the index of the slide with matching model_name
      let count = jQuery(`#PopupModal-detail .swiper-slide[model_name="${modelName}"]`).index();

      if (modal) modal.show(button, count + 1);
    });
  }
}

customElements.define("modal-opener1", ModalOpener1);


// 

class ModalDialog2 extends HTMLElement {
    constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );

    this.slider = new Swiper(".realization-slider", {
      slidesPerView: 1,
      effect: "fade",
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });

    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener, slideIndex) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");

    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();

    // Jump directly to the exact index
    this.slider.slideTo(slideIndex);
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog2", ModalDialog2);

class ModalOpener2 extends HTMLElement {
    constructor() {
    super();
    const button = this.querySelector("button");
    if (!button) return;

    button.addEventListener("click", (e) => {
      const modal = document.querySelector(this.getAttribute("data-modal"));

      // Find the index of THIS card among all cards
      let clickedIndex = this.closest(".multicolumn-list__item")?.getAttribute("id").split("-").pop();

      // Convert to integer
      clickedIndex = parseInt(clickedIndex, 10) - 1; 

      if (modal && clickedIndex >= 0) {
        modal.show(button, clickedIndex);
      }
    });
  }
}
customElements.define("modal-opener2", ModalOpener2);


// 3rd

class ModalDialog3 extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );

    this.slider = new Swiper(".realization-slider", {
      slidesPerView: 1,
      effect: "fade",
      pagination: { el: ".swiper-pagination", clickable: true },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });

    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener, slideIndex) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");

    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();

    // open exact clicked slide
    this.slider.slideTo(slideIndex);
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog3", ModalDialog3);

class ModalOpener3 extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("button");
    if (!button) return;

    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));

      // get index of clicked card in the list
      const parentCard = this.closest(".multicolumn-list__item");
      const allCards = [...document.querySelectorAll(".multicolumn-list__item")];
      const cardIndex = allCards.indexOf(parentCard);

      if (modal) modal.show(button, cardIndex);
    });
  }
}
customElements.define("modal-opener3", ModalOpener3);


// customElements.define("modal-opener1", ModalOpener1);


$(".all_products_show .products_data.hidden").removeClass("hidden");
let indexx = null;
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".inPut_slider_change").forEach((item) => {
    const sliderValue = item.dataset.width;
    const containerss = item
      .closest(".slider-container")
      .querySelector(".value_tooltip");
    containerss.textContent = sliderValue;
    console.log(sliderValue);
  });
});
if ($(".cart-items .cart-item").length > 0) {
  var mainProductCount = $(
    "#CartDrawer-CartItems .cart-items .cart-item"
  ).length;
  $(".cart-count-bubble span").text(mainProductCount);
}
setInterval(function () {
  var mainProductCount = $(
    "#CartDrawer-CartItems .cart-items .cart-item"
  ).length;
  $(".cart-count-bubble span").text(mainProductCount);
}, 200);
const filter_products = [];
const totalSections = 7;
const sectionWidth = 100 / totalSections;
const $allProducts = $(".all_products_show");
const $progressBarFill = $(".progress_bar_wrapper .progress_bar_fill");
const $pageWidth = $(".page-width");
function updateTooltip($slider, $tooltip) {
  const value = $slider.val();
  const sliderWidth = $slider.outerWidth();
  const max = $slider.attr("max");
  const min = $slider.attr("min");
  const percent = (value - min) / (max - min);
  const offset = percent * (sliderWidth - 20);
  const initialOffset = -32;
  let unit = "m";
  if (indexx === 5) {
    unit = "cm";
  } else if (indexx === 4) {
    unit = "";
  } else {
    unit = "m";
  }
  $tooltip.text(`${value}${unit}`);
  $tooltip.css("left", `${offset + initialOffset}px`);
  return value;
}

// Function to update products based on the slider value
function updateProducts(newValue, index, parents) {
  const matched = parents.toLowerCase().replace(/\s+/g, "-");

  document.querySelectorAll(".all_products_show").forEach((mainitem) => {
    Array.from(mainitem.querySelectorAll(".all_products_show .products_data"))
      .filter((item) => !item.classList.contains("checkss")) // Only process visible items
      .forEach((item) => {
        const attrValue = item.getAttribute(`data-step${index}`);
        const pre = index > 3 ? index - 1 : null;
        const pre_pre = index > 3 ? index - 2 : null;
        const preValue = pre ? item.getAttribute(`data-step${pre}`) : null;
        const prevalues = filter_products[`step${pre}`];
        const preValuemin =
          item.getAttribute(`data-step${pre_pre}-${matched}-min`) || 0;
        const preValuemax =
          item.getAttribute(`data-step${pre_pre}-${matched}-max`) || 0;
        const pre_prevalues = filter_products[`step${pre_pre}`];

        // if (
        //     attrValue === newValue &&
        //     parseFloat(prevalues) >= parseFloat(preValuemin) &&
        //     parseFloat(prevalues) <= parseFloat(preValuemax)
        // ) {
        //     item.classList.remove("hidden");
        // } else {
        //     item.classList.add("hidden");
        // }
        if (parseFloat(attrValue) === parseFloat(newValue)) {
          item.classList.remove("hidden");
          console.log(item, "true");
        } else {
          console.log(item);
          item.classList.add("hidden");
        }
      });
  });
}
function Custom_filter_5(newValue, index, parents) {
  filter_products[`step${index}`] = newValue;

  const matched = parents.toLowerCase().replace(/\s+/g, "-");

  document.querySelectorAll(".all_products_show").forEach((mainitem) => {
    mainitem
      .querySelectorAll(".all_products_show .products_data")
      .forEach((item) => {
        const attrValue = parseFloat(item.getAttribute(`data-step${index}`));
        const attrValues = item.getAttribute(`data-title${index}`);
        const pre = index > 3 ? index - 1 : null;

        /** previous data */
        const preValue = pre ? item.getAttribute(`data-step${pre}`) : null;
        const preValuemin =
          item.getAttribute(`data-step${pre}-${matched}-min`) || 0;
        const preValuemax =
          item.getAttribute(`data-step${pre}-${matched}-max`) || 0;
        const prevalues = filter_products[`step${pre}`];

        /** previous data step3*/
        const pre3 = index > 3 ? index - 2 : null;
        const preValue3 = pre3 ? item.getAttribute(`data-step${pre}`) : null;
        const preValuemin3 =
          item.getAttribute(`data-step${pre3}-${matched}-min`) || 0;
        const preValuemax3 =
          item.getAttribute(`data-step${pre3}-${matched}-max`) || 0;
        const prevalues3 = filter_products[`step${pre3}`];

        if (
          newValue.split(", ").includes(attrValues) &&
          parseFloat(prevalues) >= parseFloat(preValuemin) &&
          parseFloat(prevalues) <= parseFloat(preValuemax) &&
          parseFloat(prevalues3) >= parseFloat(preValuemin3) &&
          parseFloat(prevalues3) <= parseFloat(preValuemax3)
        ) {
          item.classList.remove("hidden");
          console.log(item, "item");
          item.classList.remove("checkss");
        } else {
          item.classList.add("hidden");
          item.classList.add("checkss");
        }
      });
  });
}
function Custom_filter_3_4(newValue, index, parents) {
  const matched = parents.toLowerCase().replace(/\s+/g, "-");

  document.querySelectorAll(".all_products_show").forEach((mainitem) => {
    mainitem.querySelectorAll(".products_data").forEach((item) => {
      const attrValue = item.getAttribute(`data-step${index}`);
      const min =
        parseFloat(item.getAttribute(`data-step${index}-${matched}-min`)) || 0;
      const max =
        parseFloat(item.getAttribute(`data-step${index}-${matched}-max`)) || 0;

      /** previous values */
      const pre = index >= 4 ? index - 1 : null;
      const preValuemin =
        item.getAttribute(`data-step${pre}-${matched}-min`) || 0;
      const preValuemax =
        item.getAttribute(`data-step${pre}-${matched}-max`) || 0;
      const prevalues = filter_products[`step${pre}`];

      console.log(newValue, min, max, "Custom_filter_3_4");

      if (pre) {
        if (
          parseFloat(newValue) >= min &&
          parseFloat(newValue) <= max &&
          parseFloat(prevalues) >= preValuemin &&
          parseFloat(prevalues) <= preValuemax
        ) {
          item.classList.remove("hidden");
        } else {
          item.classList.add("hidden");
        }
      } else {
        if (parseFloat(newValue) >= min && parseFloat(newValue) <= max) {
          item.classList.remove("hidden");
        } else {
          //console.log(index, newValue, min, max, "else matched");
          item.classList.add("hidden");
        }
      }
    });
  });
}
$(".inPut_slider_change").each(function () {
  const $slider = $(this);
  const $tooltip = $slider.closest(".slider-container").find(".value_tooltip");
  const $parentDiv = $slider.closest(".formsection");
  const sectionIndex = Number($parentDiv.attr("data-section"));
  $slider.on("input", function (e) {
    const parentsElement = e.target
      .closest(".formsection")
      .querySelector(".main_swiper");
    const parents = parentsElement
      ? parentsElement.getAttribute("matched")
      : "";
    const newValue = updateTooltip($slider, $tooltip);
    const sectionValue = e.target
      .closest(".choose_step")
      ?.getAttribute("data-section");
    const isStep5 = sectionValue === "5";
    const isStep3or4 = sectionValue === "3" || sectionValue === "4";
    index = sectionValue;

    if (isStep5) {
      const numericValue = Number(newValue);
      let title_for_match = "all";
      if (numericValue >= 0 && numericValue <= 3) {
        title_for_match =
          "inka, plano, sydney, bora, lima, miami, flexa, virtuoso, vastera, toledo, peninsula, baryton, harmonie, locco, altesse, sara, torro, jakarta";
      } else if (numericValue >= 4 && numericValue <= 6) {
        title_for_match =
          "inka, plano, sydney, bora, lima, miami, toledo, peninsula, locco, altesse, sara, torro, jakarta";
      } else if (numericValue === 7 || numericValue === 8) {
        title_for_match =
          "inka, bora, lima, miami, vastera, toledo, locco, sara, torro";
      } else if (numericValue === 9 || numericValue === 10) {
        title_for_match = "lima, miami, bora, locco, sara, toledo";
      }

      // filter_products[`step${sectionIndex}`] = title_for_match;
      // consoole.log(filter_products[`step${sectionIndex}`] = title_for_match)
      Custom_filter_5(title_for_match, sectionIndex, parents);
      // Custom_filter_5(newValue, sectionIndex,parents)
    } else if (isStep3or4) {
      filter_products[`step${sectionIndex}`] = newValue;
      Custom_filter_3_4(newValue, sectionIndex, parents);
    } else {
      filter_products[`step${sectionIndex}`] = newValue;
      updateProducts(newValue, sectionIndex, parents);
    }
  });
  // updateTooltip($slider, $tooltip);
});

$(".back_btn_arrow").click(function () {
  const $activeSec = $(this).closest(".formsection");
  let activeSec = parseInt($activeSec.attr("data-section"));
  if (activeSec === 6) {
    $(".slider-container span#slider-values").text(`1`);
  } else if (activeSec === 5) {
    $(".slider-container span#slider-values").text(`0cm`);
  }
  const newActive = activeSec - 1;
  const newWidth = newActive * sectionWidth;
  if (newActive === 1) {
    $allProducts.hide();
  } else {
    $allProducts.show();
  }
  $progressBarFill.css("width", `${newWidth}%`);
  $pageWidth.find(".formsection.active").removeClass("active");
  $pageWidth
    .find(`.formsection[data-section="${newActive}"]`)
    .addClass("active");
});

function counter(count) {
  document
    .querySelectorAll("#Step7 .products_data:not(.hidden)")
    .forEach((item, index) => {
      const existingSpan = document.querySelector(
        "#Step7 .collection_list_steps"
      );
      if (existingSpan) existingSpan.innerHTML = "";
      const images = item.getAttribute("data-step7");
      const txt = item.getAttribute("data-step8")?.split(",") || [];
      const formattedText = txt.map((value) => value.trim()).join("<br>"); // Format with line breaks

      const innerhtml = `<div class="collection_item active_div" data-search="Canapé droit">
                    <div class="collect_media">
                      <img src="${images}" alt="Icon">
                    </div>
                    <div class="collect_content">${formattedText}</div>
                  </div>`;
      existingSpan.innerHTML = innerhtml;
    });
}
$("#Step1 span.btn_primary, .next_btn_arrow").click(function (event) {
  event.preventDefault();
  const $activeSec = $(this).closest(".formsection");
  let activeSec = parseInt($activeSec.attr("data-section"));
  indexx = activeSec;
  if (activeSec === 4) {
    $(".slider-container span#slider-values").text(`0`);
    // search = [];
    //   search.push($('.collection_item.active_div').attr("data-search"));
    //   let minValue = Infinity;

    //   // Loop through all products
    //   $allProducts.each((_, mainitem) => {
    //     mainitem.querySelectorAll(".products_data").forEach((item) => {
    //       const collection = String(item.getAttribute("collection") || "")
    //         .replace(/[\s’']/g, '')
    //         .toLowerCase();

    //       const normalizedSearch = search.map(searchItem =>
    //         searchItem.replace(/[\s’']/g, '').toLowerCase()
    //       );

    //       const normalizedSearchh = search.map(searchItem =>
    //         searchItem.replace(/[\s’']/g, '-').toLowerCase()
    //       );

    //       const matches = normalizedSearch.some(searchItem => collection.includes(searchItem));

    //         // Check visibility before calculating the min value
    //         if (!$(item).hasClass('hidden')) {
    //           normalizedSearchh.forEach(searchItem => {
    //             const attrVal = item.getAttribute(`data-step5`);
    //             if (attrVal !== null) {
    //               const num = parseFloat(attrVal);
    //               if (!isNaN(num) && num < minValue) {
    //                 minValue = num;
    //               }
    //             }
    //           });
    //         }

    //       //const preValuemin = item.getAttribute(`data-step4-${matches}-min`) || 0;
    //     });
    //   });

    //   if (isFinite(minValue)) {
    //     const $slider = $('#width_sliders_depth_range');
    //     $slider.attr('min', minValue);
    //     $slider.val(minValue);
    //     $slider.trigger('input');
    //   }
  } else if (activeSec === 5) {
    $(".slider-container span#slider-values").text(`0cm`);

    search = [];
    search.push($(".collection_item.active_div").attr("data-search"));
    let minValue = Infinity;

    // Loop through all products
    $allProducts.each((_, mainitem) => {
      mainitem.querySelectorAll(".products_data").forEach((item) => {
        const collection = String(item.getAttribute("collection") || "")
          .replace(/[\s’']/g, "")
          .toLowerCase();

        const normalizedSearch = search.map((searchItem) =>
          searchItem.replace(/[\s’']/g, "").toLowerCase()
        );

        const normalizedSearchh = search.map((searchItem) =>
          searchItem.replace(/[\s’']/g, "-").toLowerCase()
        );

        const matches = normalizedSearch.some((searchItem) =>
          collection.includes(searchItem)
        );

        // Check visibility before calculating the min value
        if (!$(item).hasClass("hidden")) {
          normalizedSearchh.forEach((searchItem) => {
            const attrVal = item.getAttribute(`data-step6`);
            if (attrVal !== null) {
              const num = parseFloat(attrVal);
              if (!isNaN(num) && num < minValue) {
                minValue = num;
              }
            }
          });
        }

        //const preValuemin = item.getAttribute(`data-step4-${matches}-min`) || 0;
      });
    });

    if (isFinite(minValue)) {
      const $slider = $("#width_sliders_scale_range");
      $slider.attr("min", minValue);
      $slider.val(minValue);
      $slider.trigger("input");
    }
  }
  const newActive = activeSec + 1;
  const newWidth = newActive * sectionWidth;
  if (newActive === 1) {
    $allProducts.hide();
  } else {
    $allProducts.show();
  }
  $pageWidth.find(".formsection.active").removeClass("active");
  $pageWidth
    .find(`.formsection[data-section="${newActive}"]`)
    .addClass("active");
  $progressBarFill.css("width", `${newWidth}%`);

  if (activeSec === 2) {
    search = [];
    search.push($(".collection_item.active_div").attr("data-search"));
    let minValue = Infinity;
    // Loop through all products
    $allProducts.each((_, mainitem) => {
      mainitem.querySelectorAll(".products_data").forEach((item) => {
        const collection = String(item.getAttribute("collection") || "")
          .replace(/[\s’']/g, "")
          .toLowerCase();

        const normalizedSearch = search.map((searchItem) =>
          searchItem.replace(/[\s’']/g, "").toLowerCase()
        );

        const normalizedSearchh = search.map((searchItem) =>
          searchItem.replace(/[\s’']/g, "-").toLowerCase()
        );

        const matches = normalizedSearch.some((searchItem) =>
          collection.includes(searchItem)
        );

        // Show or hide the item based on match
        if (matches) {
          item.classList.remove("hidden");

          normalizedSearchh.forEach((searchItem) => {
            console.log(searchItem);
            const attrVal = item.getAttribute(`data-step3-${searchItem}-min`);
            if (attrVal !== null) {
              const num = parseFloat(attrVal);
              if (!isNaN(num) && num < minValue) {
                minValue = num;
              }
            }
          });
        } else {
          item.classList.add("hidden");
        }

        const preValuemin = item.getAttribute(`data-step2-${matches}-min`) || 0;
      });
    });

    if (isFinite(minValue)) {
      const $slider = $("#slider-width");
      $slider.attr("min", minValue);
      $slider.val(minValue);
      $slider.trigger("input");
    }
  } else if (activeSec === 3) {
    search = [];
    search.push($(".collection_item.active_div").attr("data-search"));
    let minValue = Infinity;

    // Loop through all products
    $allProducts.each((_, mainitem) => {
      mainitem.querySelectorAll(".products_data").forEach((item) => {
        const collection = String(item.getAttribute("collection") || "")
          .replace(/[\s’']/g, "")
          .toLowerCase();

        const normalizedSearch = search.map((searchItem) =>
          searchItem.replace(/[\s’']/g, "").toLowerCase()
        );

        const normalizedSearchh = search.map((searchItem) =>
          searchItem.replace(/[\s’']/g, "-").toLowerCase()
        );

        const matches = normalizedSearch.some((searchItem) =>
          collection.includes(searchItem)
        );

        // Check visibility before calculating the min value
        if (!$(item).hasClass("hidden")) {
          normalizedSearchh.forEach((searchItem) => {
            const attrVal = item.getAttribute(`data-step4-${searchItem}-min`);
            if (attrVal !== null) {
              const num = parseFloat(attrVal);
              if (!isNaN(num) && num < minValue) {
                minValue = num;
              }
            }
          });
        }

        //const preValuemin = item.getAttribute(`data-step4-${matches}-min`) || 0;
      });
    });

    if (isFinite(minValue)) {
      const $slider = $("#slider-depth");
      $slider.attr("min", minValue);
      $slider.val(minValue);
      $slider.trigger("input");
    }
  }
});

let search = [];

$("div#Step2 .collection_list_steps .collection_item").click(function () {
  // Mark this item as active and remove active from siblings
  $(this).addClass("active_div").siblings().removeClass("active_div");

  // Reset and set the search array
  search = [];
  search.push($(this).attr("data-search"));
  let minValue = Infinity;
  // Loop through all products
  $allProducts.each((_, mainitem) => {
    mainitem.querySelectorAll(".products_data").forEach((item) => {
      const collection = String(item.getAttribute("collection") || "")
        .replace(/[\s’']/g, "")
        .toLowerCase();

      const normalizedSearch = search.map((searchItem) =>
        searchItem.replace(/[\s’']/g, "").toLowerCase()
      );

      const matches = normalizedSearch.some((searchItem) =>
        collection.includes(searchItem)
      );

      // Show or hide the item based on match
      if (matches) {
        item.classList.remove("hidden");
      } else {
        item.classList.add("hidden");
      }

      const preValuemin = item.getAttribute(`data-step2-${matches}-min`) || 0;
    });
  });

  // Set 'matched' attribute for next step use
  const textt = $(this).attr("data-search");
  $(".main_swiper").attr("matched", textt);

  // Enable the next button
  $(this).parents("#Step2").find(".next_btn_arrow").removeClass("disable");
});

let searchlast = [];
$("div#Step7 .collection_list_steps .collection_item").click(function () {
  let searchlast = [];
  $(this).toggleClass("active_div");
  $("div#Step7 .collection_list_steps .active_div").each(function () {
    searchlast.push($(this).attr("data-search"));
  });

  let totalActive = $("div#Step7 .collection_list_steps .active_div").length;
  if ($(this).hasClass("active_div")) {
    $(this).find(".repeat-count").show();
    $(this).find(".repeat-count").text(totalActive);
  } else {
    $(this).find(".repeat-count").hide();
    $(this).find(".repeat-count").text("");
  }

  $allProducts.each((_, mainitem) => {
    mainitem.querySelectorAll(".products_data").forEach((item) => {
      const stepValues = item.getAttribute("data-step8")?.split(",") || []; // Split into array
      const isVisible = stepValues.some((value) =>
        searchlast.includes(value.trim())
      ); // Check match
      // alert(isVisible);
      const matched = $(".formsection .main_swiper")
        .attr("matched")
        .toLowerCase()
        .replace(/\s+/g, "-");

      var width_slider = $("#slider-width").val();
      const width_min =
        parseFloat(item.getAttribute(`data-step3-${matched}-min`)) || 0;
      const width_max =
        parseFloat(item.getAttribute(`data-step3-${matched}-max`)) || 0;

      var depth = $("#slider-depth").val();
      const depth_min =
        parseFloat(item.getAttribute(`data-step4-${matched}-min`)) || 0;
      const depth_max =
        parseFloat(item.getAttribute(`data-step4-${matched}-max`)) || 0;

      var convertible_scale = $("#width_sliders_depth_range").val();
      const convertible_scale_val = item.getAttribute(`data-title5`);

      const numericValue = Number(convertible_scale);
      let title_for_match = "all";

      if (numericValue >= 0 && numericValue <= 3) {
        title_for_match =
          "inka, plano, sydney, bora, lima, miami, flexa, virtuoso, vastera, toledo, peninsula, baryton, harmonie, locco, altesse, sara, torro, jakarta";
      } else if (numericValue >= 4 && numericValue <= 6) {
        title_for_match =
          "inka, plano, sydney, bora, lima, miami, toledo, peninsula, locco, altesse, sara, torro, jakarta";
      } else if (numericValue === 7 || numericValue === 8) {
        title_for_match =
          "inka, bora, lima, miami, vastera, toledo, locco, sara, torro";
      } else if (numericValue === 9 || numericValue === 10) {
        title_for_match = "lima, miami, bora, locco, sara, toledo";
      }

      var height_need = $("#width_sliders_scale_range").val();
      const height_need_val = parseFloat(item.getAttribute(`data-step6`)) || 0;

      if (
        isVisible &&
        parseFloat(width_slider) >= width_min &&
        parseFloat(width_slider) <= width_max &&
        parseFloat(depth) >= depth_min &&
        parseFloat(depth) <= depth_max &&
        title_for_match.split(", ").includes(convertible_scale_val) &&
        parseFloat(height_need_val) === parseFloat(height_need)
      ) {
        item.classList.remove("hidden");
      } else {
        item.classList.add("hidden");
      }

      // item.classList.toggle("hidden", !isVisible); // Toggle visibility
    });
  });

  $("div#Step7 .collection_list_steps .active_div").each(function (index) {
    $(this)
      .find(".repeat-count")
      .text(index + 1); // Update count starting from 1
  });
});

const collectionslider = new Swiper(".collection__list-wrappper.noss", {
  slidesPerView: 5,
  // spaceBetween: 14,
  // slideToClickedSlide: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    390: {
      slidesPerView: 3,
    },
    640: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 15,
    },
    1440: {
      slidesPerView: 5,
    },
  },
});

// customcode end

const stepEle = document.querySelector(".steps-slider");

var posterslider = new Swiper(".object-box-poster", {
  spaceBetween: 8,
  pagination: {
    slidesPerView: 1,
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 1,
      spaceBetween: 8,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 8,
    },
    1024: {
      slidesPerView: 2.1,
      spaceBetween: 8,
    },
  },
});

const instaslider = new Swiper(".insta_siders", {
  loop: true,
  slidesPerView: 4,
  spaceBetween: 20,
  slideToClickedSlide: true,
  allowTouchMove: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 1.5,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 2.5,
      spaceBetween: 15,
    },
    1440: {
      slidesPerView: 4,
    },
  },
});
const accordian_slider = new Swiper(".accordian_slider", {
  loop: true,
  slidesPerView: 2,
  spaceBetween: 20,
  slideToClickedSlide: true,
  allowTouchMove: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    390: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    1440: {
      slidesPerView: 2,
    },
  },
});
// $(".collection__list-wrappper").slick({
//   slidesToShow: 5,
//   slidesToScroll: 1,
//   arrows: true,
//   dots: false,
//   speed: 300,
//   infinite: true,
//   autoplaySpeed: 5000,
//   autoplay: true,
//   prevArrow:
//     '<div class="prev_arrow"><svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.0137 0.999768C13.0137 0.613168 12.7003 0.299768 12.3137 0.299768L6.01371 0.299767C5.62711 0.299767 5.31371 0.613168 5.31371 0.999767C5.31371 1.38637 5.62711 1.69977 6.01371 1.69977H11.6137V7.29977C11.6137 7.68637 11.9271 7.99977 12.3137 7.99977C12.7003 7.99977 13.0137 7.68637 13.0137 7.29977L13.0137 0.999768ZM1.49497 12.8085L12.8087 1.49474L11.8187 0.504793L0.505025 11.8185L1.49497 12.8085Z" fill="white"></path></svg></div>',
//   nextArrow:
//     '<div class="next_arrow"><svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.0137 0.999768C13.0137 0.613168 12.7003 0.299768 12.3137 0.299768L6.01371 0.299767C5.62711 0.299767 5.31371 0.613168 5.31371 0.999767C5.31371 1.38637 5.62711 1.69977 6.01371 1.69977H11.6137V7.29977C11.6137 7.68637 11.9271 7.99977 12.3137 7.99977C12.7003 7.99977 13.0137 7.68637 13.0137 7.29977L13.0137 0.999768ZM1.49497 12.8085L12.8087 1.49474L11.8187 0.504793L0.505025 11.8185L1.49497 12.8085Z" fill="white"></path></svg></div>',
//   responsive: [
//     {
//       breakpoint: 991,
//       settings: {
//         slidesToShow: 3,
//       },
//     },
//     {
//       breakpoint: 767,
//       settings: {
//         slidesToShow: 2,
//         centerMode: true,
//         centerPadding: "20px",
//       },
//     },
//   ],
// });

const blockslider = new Swiper(".block-slider", {
  slidesPerView: 2,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 4,
    },
    1440: {
      slidesPerView: 6,
    },
  },
});

// const fabricmodelslider = new Swiper(".fabric-models-slider", {
//   slidesPerView: 3,
//   pagination: {
//     el: ".swiper-pagination",
//     clickable: true,
//   },
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   breakpoints: {
//     768: {
//       slidesPerView: 1,
//     },
//     1024: {
//       slidesPerView: 3,
//     },
//     1440: {
//       slidesPerView: 3,
//     },
//   },
// });

document.addEventListener("DOMContentLoaded", function () {
  const fabricModelSliderEl = document.querySelector(".fabric-models-slider");

  if (fabricModelSliderEl) {
    const fabricmodelslider = new Swiper(fabricModelSliderEl, {
      slidesPerView: 3,
      pagination: {
        el: fabricModelSliderEl.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: fabricModelSliderEl.querySelector(".swiper-button-next"),
        prevEl: fabricModelSliderEl.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 3,
        },
        1440: {
          slidesPerView: 3,
        },
      },
      // **Drag/swipe related settings**
      simulateTouch: true, // Allow touch events on desktop
      touchRatio: 1, // Sensitivity to swipe
      touchAngle: 45, // Swipe tolerance angle (change if you want more flexibility)
      grabCursor: true, // Cursor turns into grab hand on hover
      resistance: true, // Allows "resistance" when dragging to the ends
      loop: true,
    });
  }
});
$(document).ready(function () {
  $(".timeline-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
     infinite:true,
    asNavFor: ".slider-milestones-years",
  });

  $(".slider-milestones-years").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".timeline-slider",
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 991,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          infinite:true,
          centerMode: true,
          centerPadding:"20px"
        },
      },
    ],
  });

  // Progress Bar Logic
  const $progressBar = $(".progress-bar");
  const totalSlides = $(".timeline-slider .slick-slide").not(".slick-cloned").length;

  $(".timeline-slider").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    const progressPercentage = ((nextSlide + 1) / totalSlides) * 100;
    $progressBar.css("width", `${progressPercentage}%`);
  });

  // Initialize Progress Bar
  const initialProgress = (1 / totalSlides) * 100;
  $progressBar.css("width", `${initialProgress}%`);
});

class BeforeAfter extends HTMLElement {
  constructor() {
    super();
    let active = false;
    let container = this;
    let wrapper = this.querySelector(".wrapper");
    this.querySelector(".scroller").addEventListener("mousedown", function () {
      active = true;
      container.querySelector(".scroller").classList.add("scrolling");
    });

    this.addEventListener("mouseup", function () {
      active = false;
      container.querySelector(".scroller").classList.remove("scrolling");
    });
    this.addEventListener("mouseleave", function () {
      active = false;
      container.querySelector(".scroller").classList.remove("scrolling");
    });

    this.addEventListener("mousemove", function (e) {
      if (!active) return;

      let x = e.pageX;

      x -= container.querySelector(".wrapper").getBoundingClientRect().left;

      scrollIt(x);
    });

    function scrollIt(x) {
      let transform = Math.max(0, Math.min(x, wrapper.offsetWidth));
      container.querySelector(".after-part").style.width = transform + "px";
      container.querySelector(".scroller").style.left = transform - 16 + "px";
    }

    const initalPos = this.querySelector(".wrapper").offsetWidth;
    this.querySelector(".wrapper").addEventListener("click", function (e) {
      scrollIt(e.offsetX);
    });
    scrollIt(initalPos / 2);

    this.querySelector(".scroller").addEventListener("touchstart", function () {
      active = true;
      container.querySelector(".scroller").classList.add("scrolling");
    });
    this.addEventListener("touchend", function () {
      active = false;
      container.querySelector(".scroller").classList.remove("scrolling");
    });
    this.addEventListener("touchcancel", function () {
      active = false;
      container.querySelector(".scroller").classList.remove("scrolling");
    });
    this.addEventListener("touchmove", function (e) {
      if (!active) return;
      let x = e.changedTouches[0].pageX;
      x -= container.querySelector(".wrapper").getBoundingClientRect().left;
      scrollIt(x);
    });
  }
  connectedCallback() {}
}
customElements.define("before-after", BeforeAfter);

// class ModalDialog1 extends HTMLElement {
//   constructor() {
//     super();
//     this.querySelector('[id^="ModalClose-"]').addEventListener(
//       "click",
//       this.hide.bind(this, false)
//     );
//     this.slider = new Swiper(".realization-slider", {
//       slidesPerView: 1,
//       effect: "fade",
//       pagination: {
//         el: ".swiper-pagination",
//         clickable: true,
//       },
//       navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev",
//       },
//     });
//     this.addEventListener("keyup", (event) => {
//       if (event.code.toUpperCase() === "ESCAPE") this.hide();
//     });
//     if (this.classList.contains("media-modal")) {
//       this.addEventListener("pointerup", (event) => {
//         if (
//           event.pointerType === "mouse" &&
//           !event.target.closest("deferred-media, product-model")
//         )
//           this.hide();
//       });
//     } else {
//       this.addEventListener("click", (event) => {
//         if (event.target === this) this.hide();
//       });
//     }
//   }

//   connectedCallback() {
//     if (this.moved) return;
//     this.moved = true;
//     document.body.appendChild(this);
//   }

//   show(opener, index) {
//     this.openedBy = opener;
//     const popup = this.querySelector(".template-popup");
//     document.body.classList.add("overflow-hidden");
//     this.setAttribute("open", "");
//     if (popup) popup.loadContent();
//     trapFocus(this, this.querySelector('[role="dialog"]'));
//     window.pauseAllMedia();
//     // console.log('inside show')
//     var mName = jQuery(opener).parents('.swiper-slide').attr('data-model-name');
//     var scrolled = false;
//     if(jQuery(opener).parents('.swiper-slide').hasClass('swipp')){
//       if(mName){
//           var idx = jQuery('#PopupModal-detail .swiper-slide[model_name="'+mName +'"]').index()
//           this.slider.slideTo(idx);
//       }else{
//         this.slider.slideTo(index - 1);
//       }
//     }else{
//       var mName2 = jQuery(opener).parents('.swiper-slides').attr('data-model-name');
//       if(mName2){
//           var idx = jQuery('#PopupModal-detail .swiper-slide[model_name="'+mName2 +'"]').index()
//           this.slider.slideTo(idx);
//       }else{
//         this.slider.slideTo(index - 1);
//       }
//     }
//   }

//   hide() {
//     document.body.classList.remove("overflow-hidden");
//     document.body.dispatchEvent(new CustomEvent("modalClosed"));
//     this.removeAttribute("open");
//     removeTrapFocus(this.openedBy);
//     window.pauseAllMedia();
//   }
// }
// customElements.define("modal-dialog1", ModalDialog1);
// class ModalOpener1 extends HTMLElement {
//   constructor() {
//     super();
//     const button = this.querySelector("button");

//     if (!button) return;
//     button.addEventListener("click", () => {
//       const modal = document.querySelector(this.getAttribute("data-modal"));
//       const index = button.getAttribute("data-target");
//       console.log('modal', modal)
//       console.log('index', index)
//       if (modal) modal.show(button, index);
//     });
//   }
// }
// customElements.define("modal-opener1", ModalOpener1);

let SwiperTop = new Swiper(".swiper--top", {
  spaceBetween: 0,
  centeredSlides: true,
  speed: 6000,
  autoplay: {
    delay: 1,
  },
  loop: true,
  slidesPerView: "auto",
  allowTouchMove: false,
  disableOnInteraction: true,
});

let SwiperBottom = new Swiper(".swiper--bottom", {
  spaceBetween: 0,
  centeredSlides: true,
  speed: 6000,
  autoplay: {
    delay: 1,
    reverseDirection: true,
  },
  loop: true,
  slidesPerView: "auto",
  allowTouchMove: false,
  disableOnInteraction: true,
});

var slider = $(".slider_card");
if (slider.length > 0) {
  slider.slick({
    slidesToShow:3,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024, // Tablet aur chhoti screen
        settings: {
          slidesToShow: 3,
          centerMode: true,
          centerPadding: "40px" // padding adjust kar sakte ho
        }
      },
      {
        breakpoint: 600, // Mobile
        settings: {
          slidesToShow: 2,
          // centerMode: true,
          // centerPadding: "30px",
        }
      }
    ]
  });
}


if (window.matchMedia("(max-width: 767px)").matches) {
  $(".all_questions").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    infinite: false,
    speed: 1500,
    arrows: false,
    centerMode: true,
    dots: false,
    centerPadding: "20px",
  });
}

// confi info popup

// fabric details for template 1
$(".accordion-content .color_lists .color_info").click(function () {
  // Get the selected color value
  var selectedValues = $(this)
    .closest(".iocn_with_custom_configuration")
    .find(".dropdown-header .color_value")
    .text();
  $(".product_wrapper").each(function () {
    var values = $(this).attr("data-value");
    if (values === selectedValues) {
      $(this).addClass("active");
    } else {
      $(this).removeClass("active");
    }
  });
});

// fabric details for template 2
$(".accordion-content .tissue_details").on("click", function () {
  var selectedValue = $(this)
    .closest(".accordion-content")
    .find("li.variant_list_wrapper.active input")
    .val();
  $(".product_wrapper").removeClass("active");

  $(".product_wrapper").each(function () {
    var values = $(this).attr("data-value");
    if (values === selectedValue) {
      $(this).addClass("active");
    } else {
      $(this).removeClass("active");
    }
    $(".info_image").each(function () {
      $(this).click(function () {
        $(this).next(".configuration_popup").css({
          opacity: "1",
          visibility: "visible",
        });
      });
    });
  });
});

// product accordin
$(document).ready(function () {
  const accordionHeaders = $(".varinst_accordion .accordion-header");
  accordionHeaders.each(function () {
    const $this = $(this);
    const isActive = $this.hasClass("active");
    $this.find(".icon-plus").toggle(!isActive);
    $this.find(".icon-minus").toggle(isActive);
    $this.next(".accordion-content").toggle(isActive);
  });
  accordionHeaders.on("click", function () {
    const $this = $(this);
    const isActive = $this.hasClass("active");
    if (!isActive) {
      $this.addClass("active");
      $this.find(".icon-plus").hide();
      $this.find(".icon-minus").show();
      $this.next(".accordion-content").slideDown();
    } else {
      $this.removeClass("active");
      $this.find(".icon-plus").show();
      $this.find(".icon-minus").hide();
      $this.next(".accordion-content").slideUp();
    }
  });
  $(".variant_list_wrapper input").each(function () {
    $(this).on("change", function () {
      const selectedValue = $(this).val();

      // Find the corresponding .accordion-item and update the .accordion-header .value text with selectedValue
      $(this)
        .closest(".accordion-item")
        .find(".accordion-header .value")
        .text(selectedValue);
    });
  });
});
$(document).on(
  "click",
  ".prouct_data .configuration_list .info_image",
  function () {
    var list = $(this).parents(".variant_list_wrapper");
    var totle = list.find("input").val();
    $(".products_wrapper").each(function () {
      var metal = $(this).attr("data-value");
      if (totle === metal) {
        $(this).addClass("active");
      } else {
        $(this).removeClass("active");
      }
    });
  }
);
// Function to toggle sidebar
function toggleSidebar(sidebar, wrapper) {
  sidebar.find(".icon-plus").hide();
  sidebar.find(".icon-minus").show();
  wrapper.addClass("active");
}
function resetSidebar(sidebar, wrapper) {
  wrapper.removeClass("active");
  sidebar.find(".icon-plus").show();
  sidebar.find(".icon-minus").hide();
}
$(".delivery_sidebar").click(function () {
  toggleSidebar($(this), $(".delivery_wrapper"));
});
$(".payment_sidebar").click(function () {
  toggleSidebar($(this), $(".payment_wrapper"));
});
$(
  ".delivery_wrapper,.payment_wrapper,.product_wrapper,.products_wrapper"
).click(function () {
  $(this).removeClass("active");
  resetSidebar($(".delivery_sidebar"), $(".delivery_wrapper"));
  resetSidebar($(".payment_sidebar"), $(".payment_wrapper"));
  $(".product_wrapper").removeClass("active");
  $(".products_wrapper").removeClass("active");
});
$(".close_btn").click(function () {
  resetSidebar($(".delivery_sidebar"), $(".delivery_wrapper"));
  resetSidebar($(".payment_sidebar"), $(".payment_wrapper"));
  $(".product_wrapper").removeClass("active");
  $(".products_wrapper").removeClass("active");
});

// price update on 3d product
$(".three_d_product .variant_list_wrapper input").click(function () {
  getVariantPrice();
  $(this)
    .closest(".variant_list")
    .find(".variant_list_wrapper")
    .removeClass("active");
  $(this).parent().addClass("active");
});
$(".three_d_product .variant_list_wrappers input").click(function () {
  $(this)
    .closest(".variant_list")
    .find(".variant_list_wrappers")
    .removeClass("active");
  $(this).parent().addClass("active");
  // const confistock =
  //   parseInt(
  //     $(
  //       ".three_d_product .configuration_list .variant_list_wrapper input:checked"
  //     ).attr("data-stocks")
  //   ) || 0;
  // const fabstock =
  //   parseInt(
  //     $(
  //       ".three_d_product .fabric_list .variant_list_wrapper.active input"
  //     ).attr("data-stock")
  //   ) || 0;
  // const fabstocks =
  //   parseInt(
  //     $(".three_d_product .variant_list_wrappers input:checked").attr(
  //       "data-stock"
  //     )
  //   ) || 0;
  // if (confistock === 0 && fabstock === 0 && fabstocks === 0) {
  //   $(".three_product_add_tocart").attr("disabled", true);
  //   $(".three_product_add_tocart span").text("Épuisé");
  // } else if (confistock === 0 || fabstock === 0 || fabstocks === 0) {
  //   $(".three_product_add_tocart").attr("disabled", true);
  //   $(".three_product_add_tocart span").text("Épuisé");
  // } else {
  //   $(".three_product_add_tocart").attr("disabled", false);
  //   $(".three_product_add_tocart span").text("Ajouter au panier");
  // }

  // Get selected configuration and prices
  const selectedConfiguration =
    $(".three_d_product .configuration_list input:checked").val() || "";

  const selectedPrice =
    parseFloat(
      $(".three_d_product .configuration_list input:checked")
        .next("label")
        .find(".price_list")
        .text()
        .replace("€", "")
        .trim()
    ) || 0;

  const selectedPrice1 =
    parseFloat(
      $(
        ".three_d_product .fabric_list_second .fabric_list .variant_list_wrapper.active input"
      )
        .attr("data-price-var")
        .replace("€", "")
        .trim()
    ) || 0;
  // Get pouf prices
  const pouf =
    parseFloat(
      $(".fabric_list_third .accordion-headers input:checked")
        .parents(".fabric_list_third")
        .find(".accordion-headers .pricess")
        .text()
        .replace("€", "")
        .trim()
    ) || 0;
  var qunat = $(
    ".accordion-headers .quantity_selector .quantity-selectors option:selected"
  ).text();
  const pouf_value =
    parseFloat(
      $(".fabric_list_third .accordion-headers input:checked")
        .parents(".fabric_list_third")
        .find(".variant_list_wrappers input:checked")
        .attr("data-price-var")
    ) || 0;
  // Calculate total price based on pouf availability
  let totalPrice;
  totalPrice =
    selectedPrice + selectedPrice1 + pouf * qunat + pouf_value * qunat;
  $(".three_d_product .button_with_price .price_wrapper .price_wrap").text(
    totalPrice + "€"
  );

  // Match variant by configuration
  const matchingVariant = $(`.varinats[data-title="${selectedConfiguration}"]`);
  if (matchingVariant.length > 0) {
    const id = matchingVariant.data("id");
    $(".three_d_product .product-variant-id").val(id);
  } else {
    $(".three_d_product .product-variant-id").val("");
  }
  //
});
function getVariantPrice() {
  // const confistock =
  //   parseInt(
  //     $(
  //       ".three_d_product .configuration_list .variant_list_wrapper input:checked"
  //     ).attr("data-stocks")
  //   ) || 0;
  // const fabstock =
  //   parseInt(
  //     $(
  //       ".three_d_product .fabric_list .variant_list_wrapper input:checked"
  //     ).attr("data-stock")
  //   ) || 0;
  // if (confistock === 0 || fabstock === 0) {
  //   $(".three_product_add_tocart").attr("disabled", true);
  //   $(".three_product_add_tocart span").text("Épuisé");
  // } else {
  //   $(".three_product_add_tocart").attr("disabled", false);
  //   $(".three_product_add_tocart span").text("Ajouter au panier");
  // }
  const selectedConfiguration =
    $(".three_d_product .configuration_list input:checked").val() || "";

  const selectedPrice =
    parseFloat(
      $(".three_d_product .configuration_list input:checked")
        .next("label")
        .find(".price_list")
        .text()
        .replace("€", "")
        .trim()
    ) || 0;

  const selectedPrice1 =
    parseFloat(
      $(
        ".three_d_product .fabric_list_second .variant_list_wrapper input:checked"
      ).attr("data-price-var")
    ) || 0;
  const pouf =
    parseFloat(
      $(".fabric_list_third .accordion-headers input:checked")
        .closest(".fabric_list_third")
        .find(".accordion-headers .pricess")
        .text()
        .replace("€", "")
        .trim()
    ) || 0;
  var qunat = $(
    ".accordion-headers .quantity_selector .quantity-selectors option:selected"
  ).text();
  const total_quantity = pouf * qunat;
  const pouf_value =
    parseFloat(
      $(".fabric_list_third .variant_list_wrappers.active input").attr(
        "data-price-var"
      )
    ) || 0;
  let totalPrice = selectedPrice + selectedPrice1;

  console.log(totalPrice, "totalPrice");

  if (pouf > 0) {
    totalPrice += total_quantity + pouf_value * qunat;
  }
  $(".three_d_product .button_with_price .price_wrapper .price_wrap").text(
    totalPrice + "€"
  );

  // Match variant by configuration
  const matchingVariant = $(`.varinats[data-title="${selectedConfiguration}"]`);

  if (matchingVariant.length > 0) {
    const id = matchingVariant.data("id");
    $(".three_d_product .product-variant-id").val(id);
  } else {
    $(".three_d_product .product-variant-id").val("");
  }
}

$(".canapelima_wrapper .variant_list_wrapper input").click(function () {
  getVariantPrice1();

  $(this)
    .closest(".variant_list")
    .find(".variant_list_wrapper")
    .removeClass("active");
  $(this).parent().addClass("active");
});

$(".custom-product-questions .all_questions button").click(function () {
  $(".custom-product-questions .all_questions button").removeClass("active");
  $(this).addClass("active");
});

//
//

$(document).ready(function () {
  const $dropdownHeader = $(".dropdown-header");
  const $dropdownMenu = $(".custom_dropdown");
  const $fabricList = $(".variant_list.tissue_list");
  const $colorOptions = $(".color_option");
  const $accordionItems = $(".canapelima_wrapper .accordion-item");
  $(".canapelima_wrapper .accordion-item").each(function () {
    const $accordionItem = $(this);
    const $firstColorOption = $accordionItem.find(".color_option").first();
    if ($firstColorOption.length) {
      const selectedId = $firstColorOption.data("vari-id");
      const selectedPrice = $firstColorOption.attr("data-price-color");
      const selectedPrice1 =
        parseFloat(selectedPrice.replace("€", "").trim()) || 0;
      const selectedStock = $firstColorOption.attr("data-stocks");
      const selectedName = $firstColorOption.find(".color_name").text();
      const $addToCartBtn = $accordionItem.find(".custom_add_to_cart");
      if (selectedStock == 0) {
        $addToCartBtn.attr("disabled", true).find("span").text("Épuisé");
      } else {
        $addToCartBtn
          .attr("disabled", false)
          .find("span")
          .text("Ajouter au panier");
      }
      const confi =
        parseFloat(
          $(
            ".canapelima_wrapper .configuration_list .variant_list_wrapper input:checked"
          )
            .next("label")
            .find(".price_list")
            .text()
            .replace("€", "")
            .trim()
        ) || 0;
      // const fabPrice = confi + selectedPrice1;
      const fabPrice = confi;
      // console.log(fabPrice, selectedPrice1);
      $(
        ".canapelima_wrapper .button_with_price .price_wrapper .price_wrap"
      ).text(fabPrice + "€");
      $accordionItem.find(".product_wrapper").removeClass("active");
      $accordionItem.find(".color_value").text(selectedName).attr({
        "data-varation": selectedId,
        "data-vari-prices": selectedPrice,
        "data-stock": selectedStock,
      });
      $accordionItem.find(".price_value").text(selectedPrice);
      $accordionItem.find(".color_list_name_warpper").val(selectedName);
      $accordionItem.find(".value_with_text .value").text(selectedName);

      $accordionItem
        .find(".variant_list.tissue_list  .variant_list_wrapper")
        .each(function () {
          const fabricId = $(this).find("input").data("variant-id");

          if (fabricId === selectedId) {
            $(this).show();
            $fabricList.css("display", "grid");
          } else {
            $(this).hide();
          }
        });
      $accordionItem.find($dropdownMenu).hide();
    }
  });
  $(document).on("click", ".fabric_list_second .color_option", function () {
    const $this = $(this);
    const selectedId = $this.data("vari-id");
    const selectedPrice = $this.attr("data-price-color");
    const selectedPrice1 =
      parseFloat(selectedPrice.replace("€", "").trim()) || 0;
    const selectedStock = $this.attr("data-stocks");
    const selectedName = $this.find(".color_name").text();
    const $currentAccordion = $this.closest(".accordion-item");
    const $addToCartBtn = $currentAccordion.find(".custom_add_to_cart");
    if (selectedStock == 0) {
      $addToCartBtn.attr("disabled", true).find("span").text("Épuisé");
    } else {
      $addToCartBtn
        .attr("disabled", false)
        .find("span")
        .text("Ajouter au panier");
    }
    const extractPrice = (selector) => {
      return parseFloat($(selector).text().replace("€", "").trim()) || 0;
    };
    const confi = extractPrice(
      $(".canapelima_wrapper input:checked").next("label").find(".price_list")
    );
    const pouf = extractPrice(
      $(".fabric_list_third .checkbox input:checked")
        .closest(".accordion-headers")
        .find(".value_with_text .pricess")
    );
    var qunat = $(
      ".accordion-headers .quantity_selector .quantity-selectors option:selected"
    ).text();
    var pouf_value = pouf * qunat;
    let poufFab = 0;
    if (pouf) {
      poufFab = extractPrice(
        $(".fabric_list_third .checkbox input:checked")
          .closest(".fabric_list_third")
          .find(".custom_configuration .price_value")
      );
    }
    let fabPrice = confi + selectedPrice1 + pouf_value + poufFab;
    $(".canapelima_wrapper .button_with_price .price_wrapper .price_wrap").text(
      fabPrice + "€"
    );
    $currentAccordion.find(".product_wrapper").removeClass("active");
    $currentAccordion.find(".color_value").text(selectedName).attr({
      "data-varation": selectedId,
      "data-vari-prices": selectedPrice,
      "data-stock": selectedStock,
    });
    $currentAccordion.find(".price_value").text(selectedPrice);
    $currentAccordion.find(".color_list_name_warpper").val(selectedName);
    $currentAccordion.find(".value_with_text .value").text(selectedName);
    $currentAccordion.find(".variant_list_wrapper").each(function () {
      const fabricId = $(this).find("input").data("variant-id");
      $(this).toggle(fabricId === selectedId);
    });
    $currentAccordion.find($dropdownMenu).hide();
  });
  $(document).on("click", ".fabric_list_third .color_option", function () {
    const $this = $(this);
    const selectedId = $this.data("vari-id");
    const selectedPrice = $this.attr("data-price-color");
    const selectedStock = parseInt($this.attr("data-stocks")) || 0;
    const selectedName = $this.find(".color_name").text().trim();
    const $currentAccordion = $this.closest(".accordion-item");
    const $addToCartBtn = $currentAccordion.find(".custom_add_to_cart");
    if (selectedStock === 0) {
      $addToCartBtn.attr("disabled", true).find("span").text("Épuisé");
    } else {
      $addToCartBtn
        .attr("disabled", false)
        .find("span")
        .text("Ajouter au panier");
    }
    const extractPrice = (selector) => {
      const priceText = $(selector).text().replace("€", "").trim();
      return parseFloat(priceText) || 0;
    };
    const confi = extractPrice(
      $(".canapelima_wrapper input:checked").next("label").find(".price_list")
    );
    const fab_new = extractPrice(
      $(".fabric_list_second .custom_configuration .price_value")
    );
    const pouf = extractPrice(
      $(".fabric_list_third .checkbox input:checked")
        .closest(".accordion-headers")
        .find(".value_with_text .pricess")
    );
    const quantity =
      parseInt(
        $(
          ".accordion-headers .quantity_selector .quantity-selectors option:selected"
        ).text()
      ) || 1;
    const poufValue = pouf * quantity;
    const selectedPrice1 =
      parseFloat(selectedPrice.replace("€", "").trim()) || 0;
    const fabPrice = confi + fab_new + poufValue + selectedPrice1;
    $(".canapelima_wrapper .button_with_price .price_wrapper .price_wrap").text(
      fabPrice + "€"
    );
    $currentAccordion.find(".product_wrapper").removeClass("active");
    $currentAccordion.find(".color_value").text(selectedName).attr({
      "data-varation": selectedId,
      "data-vari-prices": selectedPrice,
      "data-stock": selectedStock,
    });

    $currentAccordion.find(".price_value").text(selectedPrice);
    $currentAccordion.find(".color_list_name_warpper").val(selectedName);
    $currentAccordion.find(".value_with_text .value").text(selectedName);
    $currentAccordion.find(".variant_list_wrapper").each(function () {
      const fabricId = $(this).find("input").data("variant-id");
      $(this).toggle(fabricId === selectedId);
    });
    $currentAccordion.find(".dropdown-menu").hide();
  });
  //
  $(document).on(
    "click",
    ".canapelima_wrapper .fabric_list_third .variant_list_wrapper input",
    function () {
      const extractPrice = (selector) => {
        const priceText = $(selector).text().replace("€", "").trim();
        return parseFloat(priceText) || 0;
      };
      const confi = extractPrice(
        $(".canapelima_wrapper input:checked").next("label").find(".price_list")
      );
      const fab_new = extractPrice(
        $(".fabric_list_second .custom_configuration .price_value")
      );
      const pouf = extractPrice(
        $(".fabric_list_third .checkbox input:checked")
          .closest(".accordion-headers")
          .find(".value_with_text .pricess")
      );
      const quantity =
        parseInt(
          $(
            ".accordion-headers .quantity_selector .quantity-selectors option:selected"
          ).text()
        ) || 1;
      const poufValue = pouf * quantity;
      const selectedPrice1 = extractPrice(
        $(".fabric_list_third .checkbox input:checked")
          .closest(".fabric_list_third")
          .find(".custom_configuration .price_value")
      );
      const fabPrice = confi + fab_new + poufValue + selectedPrice1;
      $(
        ".canapelima_wrapper .button_with_price .price_wrapper .price_wrap"
      ).text(fabPrice + "€");
    }
  );
  //
  $(document).on(
    "click",
    ".canapelima_wrapper .fabric_list_second .variant_list_wrapper input",
    function () {
      const extractPrice = (selector) => {
        const priceText = $(selector).text().replace("€", "").trim();
        return parseFloat(priceText) || 0;
      };
      const confi = extractPrice(
        $(".canapelima_wrapper input:checked").next("label").find(".price_list")
      );
      const fab_new = extractPrice(
        $(".fabric_list_second .custom_configuration .price_value")
      );
      const pouf = extractPrice(
        $(".fabric_list_third .checkbox input:checked")
          .closest(".accordion-headers")
          .find(".value_with_text .pricess")
      );
      const quantity =
        parseInt(
          $(
            ".accordion-headers .quantity_selector .quantity-selectors option:selected"
          ).text()
        ) || 1;
      const poufValue = pouf * quantity;
      const selectedPrice1 = extractPrice(
        $(".fabric_list_third .checkbox input:checked")
          .closest(".fabric_list_third")
          .find(".custom_configuration .price_value")
      );
      const fabPrice = confi + fab_new + poufValue + selectedPrice1;
      $(
        ".canapelima_wrapper .button_with_price .price_wrapper .price_wrap"
      ).text(fabPrice + "€");
    }
  );
  //

  $accordionItems.on("click", ".dropdown-header", function (e) {
    e.stopPropagation();
    $(this).closest(".accordion-item").find($dropdownMenu).toggle();
  });
  $accordionItems.on("click", ".custom_dropdown", function (e) {
    if (!$(e.target).closest(".custom_configuration").length) {
      $(this).hide();
    }
  });
});

let customVariantIdFromFunction = null;
$(document).ready(function () {
  let selectedConfig = null;
  let selectedCustomConfigs = [];
  $('.canapelima_wrapper .configuration_list input[type="radio"]').on(
    "change",
    function () {
      if ($(this).is(":checked")) {
        // var stocks = $(this).attr("data-stockss");
        // if (stocks == 0) {
        //   $(".custom_add_to_cart").attr("disabled", true);
        //   $(".custom_add_to_cart span").text("Épuisé");
        // } else {
        //   $(".custom_add_to_cart").attr("disabled", false);
        //   $(".custom_add_to_cart span").text("Ajouter au panier");
        // }
        var confiprice = parseFloat(
          $(this)
            .next("label")
            .find(".price_list")
            .text()
            .replace("€", "")
            .trim()
        );
        var fabprice = parseFloat(
          $(".color_lists .iocn_with_custom_configuration .color_value")
            .attr("data-vari-prices")
            .replace("€", "")
            .trim()
        );
        var pouf = parseFloat(
          $(".fabric_list_third .checkbox input:checked")
            .parents(".accordion-headers")
            .find(".value_with_text .pricess")
            .text()
            .replace("€", "")
            .trim()
        );
        var qunat = $(
          ".accordion-headers .quantity_selector .quantity-selectors option:selected"
        ).text();
        var pouf_value = pouf * qunat;
        var pouf_price = parseFloat(
          $(".fabric_list_third .checkbox input:checked")
            .parents(".fabric_list_third")
            .find(".dropdown-header .price_value")
            .text()
            .replace("€", "")
            .trim()
        );
        if (pouf) {
          var total = confiprice + fabprice + pouf_value + pouf_price * qunat;
        } else {
          // var total = confiprice + fabprice;
          if (
            $(
              "ul.variant_list.tissue_list.fabric_list li.variant_list_wrapper"
            ).hasClass("active")
          ) {
            var total = confiprice + fabprice;
          } else {
            var total = confiprice;
          }
        }

        $(
          ".canapelima_wrapper .button_with_price .price_wrapper .price_wrap"
        ).text(total + "€");
        $('.custom_configuration input[type="checkbox"]').prop(
          "checked",
          false
        );
        $(".custom_configuration .variant_details").removeClass("active");
        $(".canapelima_wrapper .custom_configuration .checkbox_number")
          .text("")
          .hide();
        selectedCustomConfigs = [];
        selectedConfig = $(this).val();
        $(".configuration_list .variant_list_wrapper").removeClass("active");
        $(this).parent(".variant_list_wrapper").addClass("active");
      }
    }
  );
});

function getVariantPrice1() {
  const selectedConfiguration = $(".configuration_list input:checked").val();
  const confi = $(`.variants[data-single-title="${selectedConfiguration}"]`);
  const singleConfigId = confi.data("id");
  const singleConfigPrice = confi.data("price");

  if (singleConfigId) {
    $(".canapelima_wrapper .product-variant-id").val(singleConfigId);
    console.log(singleConfigPrice, "singleConfigPrice");
    // setTimeout(function(){
    $(".canapelima_wrapper .button_with_price .price_wrapper .price_wrap").text(
      singleConfigPrice
    );
    // }, 500);
  } else {
    console.log("No matching variant found.");
  }
}

// template 2 add to cart function
function getVariantPrice12() {
  const selectedRevetement = $(".fabric_list input:checked").val();
  const dataTitle = `Custom Configuration`;
  const matchingVariant = $(`.variants[data-title="${dataTitle}"]`);
  const dataPrice = matchingVariant.data("price");
  const id = matchingVariant.data("id");
  if (id) {
    $(".canapelima_wrapper .product-variant-id").val(id);
    $(".canapelima_wrapper .button_with_price .price_wrapper .price_wrap").text(
      dataPrice
    );
    return id;
  } else {
    console.log("No matching variant found.");
    return null;
  }
}

//
function updateItemPriceFromProperties() {
  $(".cart-item").each(function () {
    var item = $(this);
    var itemPriceElement = item.find(
      ".cart-item__totals .cart-item__price-wrapper .price"
    );
    var priceProperty = item.data("price");
    if (priceProperty) {
      itemPriceElement.text(priceProperty + "€");
    }
  });
}
// Update item price and add to cart from properties
// Template 2: Add to cart function for custom configuration
$(document).ready(function () {
  function updateAddToCartButton2() {
    // setTimeout(function(){
    const isConfigSelected =
      $('.three_d_product input[name="Configuration"]:checked').length > 0;
    const isRevetementsSelected =
      $(
        '.three_d_product .fabric_list_second .variant_list_wrapper.active input[name="Revêtements"]'
      ).length > 0;
    // const hasPoufOption =
    //   $('.three_d_product input[name="quantity_selectors"]').length > 0;
    // const isPoufSelected = hasPoufOption
    //   ? $('.three_d_product input[name="quantity_selectors"]:checked').length > 0
    //   : true;
    // const hasPoufFabOption =
    //   $('.three_d_product .fabric_list_third .variant_list_wrappers.active input[name="Revêtements"]').length >
    //   0;
    // const isPoufFabSelected = hasPoufFabOption
    //   ? $('.three_d_product .fabric_list_third .variant_list_wrappers.active input[name="Revêtements"]:checked')
    //       .length > 0
    //   : true;

    const isPoufSelected = $(
      '.three_d_product input[name="quantity_selectors"]:checked'
    ).length;
    const isPoufFabSelected =
      $(
        '.three_d_product .fabric_list_third .variant_list_wrappers.active input[name="Revêtements"]:checked'
      ).length > 0;

    let allConditionsMet = false;

    if (isConfigSelected && isRevetementsSelected) {
      if (!isPoufSelected) {
        allConditionsMet = true;
      } else if (isPoufSelected && isPoufFabSelected) {
        allConditionsMet = true;
      } else {
        allConditionsMet = false; // Covers: isPoufSelected && !isPoufFabSelected
      }
    } else {
      allConditionsMet = false;
    }

    // const allConditionsMet =
    //   isConfigSelected &&
    //   isRevetementsSelected &&
    //   isPoufSelected && isPoufFabSelected;

    // const allConditionsMet =
    //   isConfigSelected &&
    //   isRevetementsSelected &&
    //   isPoufSelected &&
    //   isPoufFabSelected;
    $(".three_d_product .button_with_price, .three_product_add_tocart").prop(
      "disabled",
      !allConditionsMet
    );
    // },100)
  }
  $(
    '.three_d_product input[name="Configuration"],' +
      '.three_d_product .fabric_list_second input[name="Revêtements"]'
    // '.three_d_product input[name="quantity_selectors"]'
    // '.three_d_product .fabric_list_third input[name="Revêtements"]'
  ).on("change", updateAddToCartButton2);

  $('.three_d_product .fabric_list_second input[name="Revêtements"]').on(
    "click",
    updateAddToCartButton2
  );

  $('.three_d_product .fabric_list_third input[name="Revêtements"]').on(
    "click",
    updateAddToCartButton2
  );

  $('.three_d_product input[name="quantity_selectors"]').on(
    "click",
    updateAddToCartButton2
  );

  updateAddToCartButton2();
});

$(
  ".three_d_product .accordion-headers .quantity_selector .quantity-selectors"
).change(function () {
  var value = $(this).find("option:selected").text();
  var confiprice =
    parseFloat(
      $(".configuration_list input:checked")
        .next("label")
        .find(".price_list")
        .text()
        .replace("€", "")
        .trim()
    ) || 0;
  var fabprice =
    parseFloat(
      $(".fabric_list_second .variant_list_wrapper.active input")
        .next("label")
        .find(".price_list")
        .text()
        .replace("€", "")
        .trim()
    ) || 0;
  var pouf =
    parseFloat(
      $(this)
        .parents(".fabric_list_third")
        .find(".accordion-headers .pricess")
        .text()
        .replace("€", "")
        .trim()
    ) || 0;
  var pou_qun = pouf * value;
  var pouf_value =
    parseFloat(
      $(this)
        .parents(".fabric_list_third")
        .find(".variant_list_wrappers.active .price_list")
        .text()
        .replace("€", "")
        .trim()
    ) || 0;

  var total = confiprice + fabprice + pou_qun + pouf_value * value;
  $(".three_d_product .button_with_price .price_wrapper .price_wrap").text(
    total + "€"
  );
});

$(".three_d_product #quantity_selector").change(function () {
  var value = $(this)
    .parents(".accordion-headers")
    .find(".quantity_selector .quantity-selectors option:selected")
    .text();
  var confiprice =
    parseFloat(
      $(".configuration_list input:checked")
        .next("label")
        .find(".price_list")
        .text()
        .replace("€", "")
        .trim()
    ) || 0;
  var fabprice =
    parseFloat(
      $(".fabric_list .variant_list_wrapper input:checked").attr(
        "data-price-var"
      )
    ) || 0;
  var pouf =
    parseFloat(
      $(this)
        .parents(".fabric_list_third")
        .find(".accordion-headers .pricess")
        .text()
        .replace("€", "")
        .trim()
    ) || 0;
  var pou_qun = pouf * value;
  var pouf_value =
    parseFloat(
      $(this)
        .parents(".fabric_list_third")
        .find(".dropdown-header .price_value")
        .text()
        .replace("€", "")
        .trim()
    ) || 0;
  var total = confiprice + fabprice + pou_qun + pouf_value * value;
  var totals = confiprice + fabprice;
  var quantitySelect = $(this)
    .parents(".fabric_list_third")
    .find(".quantity-selectors");

  if ($(this).prop("checked")) {
    $(this)
      .parents(".fabric_list_third")
      .find(".accordion-headers")
      .addClass("active");
    $(this)
      .parents(".fabric_list_third")
      .find(".accordion-content")
      .slideDown();
    quantitySelect.removeAttr("disabled");

    $(".three_d_product .button_with_price .price_wrapper .price_wrap").text(
      total + "€"
    );
  } else {
    $(this)
      .parents(".fabric_list_third")
      .find(".accordion-headers")
      .removeClass("active");
    $(this).parents(".fabric_list_third").find(".accordion-content").slideUp();
    quantitySelect.attr("disabled", "disabled");
    $(".three_d_product .button_with_price .price_wrapper .price_wrap").text(
      totals + "€"
    );
  }
});

$(".three_product_add_tocart").click(function (event) {
  event.preventDefault();

  // Find the cart element
  var cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");

  // Remove the 'is-empty' class from the drawer
  $(".drawer").removeClass("is-empty");

  // Get the primary variant ID
  var variantId1 = $(".product-form .product-variant-id").val() || null;

  // Extract and parse the price
  var priceText = $(".button_with_price .price_wrapper .price_wrap")
    .text()
    .trim();
  var price = parseFloat(priceText.replace(",", ".")) || 0;

  // Handle fabric properties
  var fabricInput = $(".fabric_list .variant_list_wrapper.active input");
  var dataId2 = fabricInput.attr("data-variant-id") || null;
  var property = fabricInput.next("label").find("img").attr("src") || "";
  var propertyName =
    fabricInput.next("label").find(".variant_title").text().trim() || "";

  // Handle configuration properties
  var configurationInput = $(
    ".configuration_list .variant_list_wrapper.active input:checked"
  );
  var titleConfig = configurationInput.val() || "";

  // Handle additional fabric selections
  var dataId = $(".fabric_list_third .checkbox input:checked")
    .closest(".fabric_list_third")
    .find("#quantity_selector")
    .val();

  // Handle quantity selection
  var quantitySelect = $("#quantitys");
  var quantitys =
    parseInt(quantitySelect.find("option:selected").text(), 10) || 1;

  // Handle pouf fabric selection
  var poufFabric =
    $(".fabric_list_third .checkbox input:checked")
      .closest(".fabric_list_third")
      .find(".variant_list_wrappers input:checked")
      .attr("data-variant-id") || null;

  var poufFabrics =
    $(".fabric_list_third .checkbox input:checked")
      .closest(".fabric_list_third")
      .find(".variant_list_wrappers input:checked")
      .val() || "";

  var poufImage =
    $(".fabric_list_third .checkbox input:checked")
      .closest(".fabric_list_third")
      .find(".variant_list_wrappers input:checked + label img")
      .attr("src") || "";

  // Generate a timestamp for tracking
  var timestamp = Date.now();

  // Build the items array
  var items = [
    {
      id: variantId1,
      quantity: 1,
      properties: {
        _Revêtements: property,
        Revêtement: propertyName,
        _Poufs: poufImage,
        ...(poufFabrics && poufFabrics.trim() !== ""
          ? { Pouf: poufFabrics }
          : {}),
        _linked_to: variantId1,
        _timestamp: timestamp,
        _price: price,
      },
    },
  ];

  // Add additional fabric variant
  if (dataId2) {
    items.push({
      id: dataId2,
      quantity: 1,
      properties: {
        _linked_to: variantId1,
        _timestamp: timestamp,
      },
    });
  }

  // Add extra items based on dataId
  if (dataId) {
    items.push({
      id: dataId,
      quantity: quantitys,
      properties: {
        _timestamp: timestamp,
        _linked_to: variantId1,
      },
    });
  }

  // Add pouf fabric if selected
  if (poufFabric) {
    items.push({
      id: poufFabric,
      quantity: quantitys,
      properties: {
        _timestamp: timestamp,
        _linked_to: variantId1,
      },
    });
  }

  // Prepare the product data for the AJAX request
  var productData = {
    items: items,
    sections:
      cart && typeof cart.getSectionsToRender === "function"
        ? cart.getSectionsToRender().map(function (section) {
            return section.id;
          })
        : [],
    sections_url: window.location.pathname,
  };

  // AJAX request to add items to the cart
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: JSON.stringify(productData),
    contentType: "application/json",
    dataType: "json",
    async: false,
    success: function (response) {
      console.log("Items added to cart:", response);

      if (cart && typeof cart.renderContents === "function") {
        cart.renderContents(response);

        // Update cart item count
        setTimeout(function () {
          var mainProductCount = $(
            "#CartDrawer-CartItems .cart-items .cart-item"
          ).length;
          $(".cart-count-bubble span").text(mainProductCount);
          $("a#cart-icon-bubble svg").remove();
          $("a#cart-icon-bubble").append(
            '<img src="//canapeo.myshopify.com/cdn/shop/files/Canapeo_Panier.png?v=1741606363" width="32" height="32">'
          );
        }, 500);
      }
    },
    error: function (xhr, status, error) {
      console.error("Error adding items to cart:", {
        status: status,
        error: error,
        response: xhr.responseText,
      });
    },
  });
});

$(document).ready(function () {
  var mac = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);

  if (mac) {
    $(".cart-drawer").load(location.href + " .cart-drawer");
  }

  function updateAddToCartButton() {
    // if($('.canapelima_wrapper input[name="Configuration"]').length > 0){
    var isConfigSelected =
      $('.canapelima_wrapper input[name="Configuration"]:checked').length > 0;
    // }else{
    //   var isConfigSelected =
    //   $('.variant_list_wrapper input[name="Configuration"]:checked').length > 0;
    // }

    // if($('.canapelima_wrapper input[name="fabric"]').length > 0){
    var isRevetementsSelected =
      // $('.canapelima_wrapper input[name="fabric"]:checked').length > 0;
      $('.canapelima_wrapper input[name="fabric"]:visible:checked').length > 0;
    // }else{
    //   var isRevetementsSelected =
    //   // $('.canapelima_wrapper input[name="fabric"]:checked').length > 0;
    //   $('.fabric_list_second .fabric_list input[name="Revêtements"]:checked').length > 0;
    // }

    const haspouf = $(
      '.canapelima_wrapper input[name="quantity_selectors"]'
    ).length;
    const isPoufSelected =
      $('.canapelima_wrapper input[name="quantity_selectors"]:checked').length >
      0;
    const isPoufFabSelected =
      $('.canapelima_wrapper .fabric_list_third input[name="fabric"]:checked')
        .length > 0;
    if (haspouf == 0) {
      console.log("iff");
      const allConditionsMet = isConfigSelected && isRevetementsSelected;
      console.log("allConditionsMet", allConditionsMet);
      $(".button_with_price,.custom_add_to_cart").prop(
        "disabled",
        !allConditionsMet
      );
    } else {
      console.log("elsee");
      const allConditionsMet = isConfigSelected && isRevetementsSelected;
      // isPoufSelected &&
      // isPoufFabSelected;
      $(".button_with_price,.custom_add_to_cart").prop(
        "disabled",
        !allConditionsMet
      );
    }
  }
  $(
    '.canapelima_wrapper input[name="Configuration"],.canapelima_wrapper input[name="fabric"],.canapelima_wrapper input[name="quantity_selectors"],.canapelima_wrapper .fabric_list_third input[name="fabric"], .fabric_list_second .fabric_list input[name="Revêtements"]'
  ).on("change", updateAddToCartButton);
  updateAddToCartButton();
});
$(
  ".canapelima_wrapper .accordion-headers .quantity_selector .quantity-selectors"
).change(function () {
  var value = $(this).find("option:selected").text();
  var confiprice =
    parseFloat(
      $(".configuration_list input:checked")
        .next("label")
        .find(".price_list")
        .text()
        .replace("€", "")
        .trim()
    ) || 0;
  var fabprice =
    parseFloat(
      $(".color_lists .iocn_with_custom_configuration .color_value")
        .attr("data-vari-prices")
        .replace("€", "")
        .trim()
    ) || 0;
  var pouf =
    parseFloat(
      $(this)
        .parents(".fabric_list_third")
        .find(".accordion-headers .pricess")
        .text()
        .replace("€", "")
        .trim()
    ) || 0;
  var pou_qun = pouf * value;
  var pouf_value =
    parseFloat(
      $(this)
        .parents(".fabric_list_third")
        .find(".dropdown-header .price_value")
        .text()
        .replace("€", "")
        .trim()
    ) || 0;
  var total = confiprice + fabprice + pou_qun + pouf_value * value;
  $(".canapelima_wrapper .button_with_price .price_wrapper .price_wrap").text(
    total + "€"
  );
});
$(".canapelima_wrapper #quantity_selector").change(function () {
  var value = $(this)
    .parents(".accordion-headers")
    .find(".quantity_selector .quantity-selectors option:selected")
    .text();
  var confiprice =
    parseFloat(
      $(".configuration_list input:checked")
        .next("label")
        .find(".price_list")
        .text()
        .replace("€", "")
        .trim()
    ) || 0;
  var fabprice =
    parseFloat(
      $(".color_lists .iocn_with_custom_configuration .color_value")
        .attr("data-vari-prices")
        .replace("€", "")
        .trim()
    ) || 0;
  var pouf =
    parseFloat(
      $(this)
        .parents(".fabric_list_third")
        .find(".accordion-headers .pricess")
        .text()
        .replace("€", "")
        .trim()
    ) || 0;
  var pou_qun = pouf * value;
  var pouf_value =
    parseFloat(
      $(this)
        .parents(".fabric_list_third")
        .find(".dropdown-header .price_value")
        .text()
        .replace("€", "")
        .trim()
    ) || 0;

  console.log(pouf_value, "value");
  var total = confiprice + fabprice + pou_qun + pouf_value * value;
  var totals = confiprice + fabprice;
  var quantitySelect = $(this)
    .parents(".fabric_list_third")
    .find(".quantity-selectors");
  if ($(this).prop("checked")) {
    $(this)
      .parents(".fabric_list_third")
      .find(".accordion-headers")
      .addClass("active");
    $(this)
      .parents(".fabric_list_third")
      .find(".accordion-content")
      .slideDown();
    quantitySelect.removeAttr("disabled");
    $(".canapelima_wrapper .button_with_price .price_wrapper .price_wrap").text(
      total + "€"
    );
  } else {
    $(this)
      .parents(".fabric_list_third")
      .find(".accordion-headers")
      .removeClass("active");
    $(this).parents(".fabric_list_third").find(".accordion-content").slideUp();
    quantitySelect.attr("disabled", "disabled");
    $(".canapelima_wrapper .button_with_price .price_wrapper .price_wrap").text(
      totals + "€"
    );
  }
});

$(".custom_add_to_cart").click(function (event) {
  event.preventDefault();
  var cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
  $(".drawer").removeClass("is-empty");
  var fabid = $(
    ".fabric_list_second .iocn_with_custom_configuration .color_value"
  ).data("varation");
  var stocktext = $(".product__info-wrapper .stock_pera p")
    .text()
    .replace(/(\d{2}\/\d{2}\/\d{4})/g, "$1");
  var fabvalue = $(
    ".fabric_list_second .iocn_with_custom_configuration .color_value"
  ).text();
  var currentColorId = $(
    ".fabric_list_second .color_lists .variant_list_wrapper.active input"
  ).data("variant-id");

  var activeColorId = null;
  var color = "";
  var text = "";
  var Revêtements = "";

  if (fabid === currentColorId) {
    activeColorId = currentColorId;
    color = $(
      ".fabric_list_second .color_lists .variant_list_wrapper.active label img"
    ).attr("src");
    text = $(
      ".fabric_list_second .color_lists .variant_list_wrapper.active label span"
    )
      .text()
      .trim();
    Revêtements = fabvalue + " " + text;
  }

  var variantId = $(
    ".canapelima_wrapper .product-form .product-variant-id"
  ).val();
  var dataId = $(".fabric_list_third .checkbox input:checked")
    .closest(".fabric_list_third")
    .find("#quantity_selector")
    .val();
  var quantitySelect = $("#quantitys");
  var quantitys = quantitySelect.find("option:selected").text();
  var pouf_fabric = $(".fabric_list_third .checkbox input:checked")
    .closest(".fabric_list_third")
    .find(".color_value")
    .data("varation");
  var poufFabricname = $(".fabric_list_third .checkbox input:checked")
    .closest(".fabric_list_third")
    .find(".color_value")
    .text();
  var poufFabriccolor = $(".fabric_list_third .checkbox input:checked")
    .closest(".fabric_list_third")
    .find(".variant_list_wrapper input:checked + label span")
    .text();
  var poufFabricImage = $(".fabric_list_third .checkbox input:checked")
    .closest(".fabric_list_third")
    .find(".variant_list_wrapper input:checked + label img")
    .attr("src");
  var poufFabrics = poufFabricname + " " + poufFabriccolor;

  var priceText = $(".button_with_price .price_wrapper .price_wrap")
    .text()
    .trim();
  var price = parseFloat(priceText.replace(",", "."));
  var items = [];
  var timestamp = Date.now();

  if (variantId) {
    items.push({
      id: variantId,
      quantity: 1,
      properties: {
        _Revêtements: color,
        Revêtement: Revêtements,
        _Poufs: poufFabricImage,
        ...(poufFabrics && poufFabrics.trim() !== ""
          ? { Pouf: poufFabrics }
          : {}),
        Stock: stocktext,
        _price: price,
        _timestamp: timestamp,
        _linked_to: variantId,
      },
    });
  }

  if (fabid) {
    items.push({
      id: fabid,
      quantity: 1,
      properties: {
        _timestamp: timestamp,
        _linked_to: variantId,
      },
    });
  }

  if (dataId) {
    items.push({
      id: dataId,
      quantity: quantitys,
      properties: {
        _timestamp: timestamp,
        _linked_to: variantId,
      },
    });
  }

  if (pouf_fabric) {
    items.push({
      id: pouf_fabric,
      quantity: quantitys,
      properties: {
        _timestamp: timestamp,
        _linked_to: variantId,
      },
    });
  }

  var productData = {
    items: items,
  };
  if (cart && typeof cart.getSectionsToRender === "function") {
    productData.sections = cart.getSectionsToRender().map(function (section) {
      return section.id;
    });
    productData.sections_url = window.location.pathname;
  }
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: JSON.stringify(productData),
    contentType: "application/json",
    dataType: "json",
    success: function (response) {
      if (cart && typeof cart.renderContents === "function") {
        cart.renderContents(response);
        setTimeout(function () {
          var mainProductCount = $(
            "#CartDrawer-CartItems .cart-items .cart-item"
          ).length;
          console.log(mainProductCount);
          $(".cart-count-bubble span").text(mainProductCount);
          $("a#cart-icon-bubble svg").remove();
          $("a#cart-icon-bubble").append(
            '<img src="//canapeo.myshopify.com/cdn/shop/files/Canapeo_Panier.png?v=1741606363" width="32" height="32">'
          );
        }, 500);
      } else {
        console.error("cart.renderContents is not a function");
      }
    },
    error: function (error) {
      console.error("Error adding to cart:", error);
      if (error.status === 422) {
        console.error(
          "Unprocessable content: Check if the variant IDs are valid."
        );
      } else {
        console.error(
          "Unexpected error:",
          error.responseJSON || error.responseText
        );
      }
    },
  });
});
$(document).on("click", ".cart-remove-button", function (event) {
  event.preventDefault();
  event.stopPropagation();
  $(".cart__checkout-button").css("pointer-events", "none");
  var productIdToRemove = $(this).attr("data-variant-id");
  $.getJSON("/cart.js", function (cart) {
    var itemsToRemove = cart.items.filter(function (item) {
      if (item.properties && item.properties._timestamp) {
        var linkedProductIds = item.properties._linked_to
          ? item.properties._linked_to.split(",")
          : [];
        return (
          item.properties._timestamp &&
          linkedProductIds.includes(productIdToRemove)
        );
      }
      return false;
    });

    if (itemsToRemove.length > 0) {
      var removeItemIds = itemsToRemove.map(function (item) {
        return item.id;
      });
      var updates = {};
      removeItemIds.forEach(function (itemId) {
        updates[itemId] = 0;
      });
      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: JSON.stringify({ updates: updates }),
        contentType: "application/json",
        dataType: "json",
        success: function (response) {
          var itemCount = response.item_count;
          console.log("Updated cart response:", response);
          if (itemCount === 0) {
            $(
              "#CartDrawer .payment_items, #CartDrawer .drawer__header"
            ).addClass("is-empty");
            $("#CartDrawer .drawer__inner-empty").css("display", "flex");
            $(".cart-count-bubble").css("display", "none");
            $(".cart-count-bubble span").text(itemCount);
          } else {
            $(".cart-count-bubble span").text(itemCount);
            $(".cart-count-bubble").css("display", "inline-block");
            $(".cart__checkout-button").text(
              "COMMANDER - " + response.items_subtotal_price / 100 + "€"
            );
          }
          $(".cart__checkout-button").css("pointer-events", "all");
        },
        error: function (error) {
          console.error("Error removing linked products:", error);
        },
      });
    } else {
      console.log(
        "No linked products found to remove with matching timestamp."
      );
    }
  });
});

//

$(document).ready(function () {
  $(".tooltip_dot").click(function (e) {
    e.stopPropagation();
    $(".tooltip_dot").removeClass("indicator-lg").addClass("indicator-sm");
    $(".tooltip").css("display", "none");
    if (!$(this).hasClass("indicator-lg")) {
      $(this).removeClass("indicator-sm").addClass("indicator-lg");
      $(this).find(".tooltip").css("display", "block");
    }
  });
  $(document).click(function () {
    $(".tooltip_dot").removeClass("indicator-lg").addClass("indicator-sm");
    $(".tooltip").css("display", "none");
  });
  $(".tooltip_dot").click(function (e) {
    e.stopPropagation();
  });
});

// read more / read less on product page

$(".product__info-wrapper .product__text .read_more").click(function () {
  console.log("clicked");
  const richText = $(this).siblings(".metafield-rich_text_field");
  if ($(this).text() === "Lire plus") {
    richText.css({ height: "auto", overflow: "visible" });
    $(this).text("Lire moins");
  } else {
    richText.css({ height: "61px", overflow: "hidden" });
    $(this).text("Lire plus");
  }
});

// accordin tooltip
$(document).ready(function () {
  $(".info_toltip").click(function () {
    $(".totlip_accordin").hide();
    $(this)
      .siblings(".accordion-button")
      .find(".accordion-title-wrap .totlip_accordin")
      .show();
  });
  $(document).click(function (event) {
    if (!$(event.target).closest(".info_toltip, .totlip_accordin").length) {
      $(".totlip_accordin").hide();
    }
  });
});

//
$(".accordion-item").each(function () {
  $(this).on("click", ".fabric_list .variant_list_wrapper", function () {
    // Retrieve the main label price and update the second fabric list price
    var main = $(".label_price .color_value").text().trim();
    $(this)
      .closest(".accordion-item")
      .find(".fabric_list_second .value_with_text .value")
      .text(main);

    // Get the price for configuration
    var confiprice =
      parseFloat(
        $(".configuration_list .variant_list_wrapper input:checked")
          .next("label")
          .find(".price_list")
          .text()
          .replace("€", "")
          .trim()
      ) || 0;

    // Get the fabric price
    var fabprice =
      parseFloat(
        $(this)
          .closest(".accordion-item")
          .find(".fabric_list_second .dropdown-header .price_value")
          .text()
          .replace("€", "")
          .trim()
      ) || 0;

    // Get the pouf price (if checked)
    var pouf =
      parseFloat(
        $(".fabric_list_third .checkbox input:checked")
          .parents(".accordion-headers")
          .find(".value_with_text .pricess")
          .text()
          .replace("€", "")
          .trim()
      ) || 0;

    // Get the pouf value from the dropdown
    var pouf_value =
      parseFloat(
        $(".fabric_list_third")
          .find(".dropdown-header .price_value")
          .text()
          .replace("€", "")
          .trim()
      ) || 0;

    // Calculate the total price based on pouf availability
    var totalPrices = confiprice + fabprice + pouf + pouf_value;

    // Update the price display for the current accordion item

    $(this)
      .closest(".accordion-item")
      .find(".canapelima_wrapper .button_with_price .price_wrapper .price_wrap")
      .text(totalPrices + "€");

    // If the item has the 'active' class, update the dropdown text
    if ($(this).hasClass("active")) {
      var text = $(this).find("label span").text().trim();
      $(this)
        .closest(".accordion-item")
        .find(".dropdown-header .dropdown-icon .dropdown-icon_color")
        .text(text);
    }
  });
});

// filter js

$(".single-mode, .double-mode").click(function () {
  const isSingleMode = $(this).hasClass("single-mode");
  $(".single-mode, .double-mode").removeClass("active");
  $(this).addClass("active");
  $("#product-grid")
    .toggleClass("single", isSingleMode)
    .toggleClass("double", !isSingleMode);
});

// Add to Wishlist Functionality

// function addToWishlist(element) {
//   const productId = element.getAttribute("data-product-id");
//   const productTitle = element.getAttribute("data-product-title");
//   const productPrice = element.getAttribute("data-product-price");
//   const productImage = element.getAttribute("data-product-image");
//   let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
//   const productIndex = wishlist.findIndex(
//     (product) => product.id === productId
//   );

//   if (productIndex === -1) {
//     wishlist.push({
//       id: productId,
//       title: productTitle,
//       price: productPrice,
//       image: productImage,
//     });
//     element.closest(".wishlist_button").classList.add("active");
//     console.log("Product added to wishlist!");
//   } else {
//     wishlist.splice(productIndex, 1);
//     element.closest(".wishlist_button").classList.remove("active");
//     console.log("Product removed from wishlist!");
//   }

//   localStorage.setItem("wishlist", JSON.stringify(wishlist));
// }
// function renderWishlist() {
//   const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
//   const wishlistContentWrapper = document.querySelector(
//     ".wishlist_list_ul.wishlist"
//   );
//   if (!wishlistContentWrapper) {
//     console.error("Wishlist content wrapper not found!");
//     return;
//   }
//   wishlistContentWrapper.innerHTML = "";
//   if (wishlist.length === 0) {
//     let emptyMessage =
//       window.wishlistSettings?.emptyText || "No products in wishlist.";
//     wishlistContentWrapper.innerHTML = `<p><img src='https://cdn.shopify.com/s/files/1/0849/4127/5404/files/wishlist.png?v=1740477731' alt='wishlist'>${emptyMessage}</p>`;
//   }

//   wishlist.forEach((product) => {
//     const productHTML = `
//       <div class="wishlist_item">
//         <div class="wish_wrapper">
//           <div class="wish_media">
//             <div class="wish_media_content">
//               <img src="${product.image}" alt="${product.title}">
//             </div>
//           </div>
//           <div class="wish_content">
//             <div class="wish_information title-price">
//               <div class="wish_title card__heading">${product.title}</div>
//               <div class="wish_price price"><span style="font-size:15px">À partir de</span> ${product.price}</div>
//             </div>
//           </div>
//         </div>
//       </div>`;
//     wishlistContentWrapper.innerHTML += productHTML;
//   });
// }
// const wishlistMenuItemLink = document.querySelector(".wishlist-menu-item a");
// if (wishlistMenuItemLink) {
//   wishlistMenuItemLink.addEventListener("click", function (e) {
//     // e.preventDefault();
//     renderWishlist();
//   });
// }
// document.addEventListener("DOMContentLoaded", function () {
//   const urlParams = new URLSearchParams(window.location.search);
//   const ordersList = document.querySelector(".orders-list");
//   const wishlistContent = document.getElementById("wishlist-content");
//   const accountUpdateForm = document.querySelector(".account-update-form");
//   const firstMenuItem = document.querySelector(".first-menu-item");
//   const secondMenuItem = document.querySelector(".second-menu-item");
//   const wishlistMenuItem = document.querySelector(".wishlist-menu-item");
//   function updateMenuActiveState(activeMenuItem) {
//     [firstMenuItem, secondMenuItem, wishlistMenuItem].forEach((item) => {
//       if (item) item.classList.remove("active");
//     });
//     if (activeMenuItem) activeMenuItem.classList.add("active");
//   }
//   if (urlParams.has("orders") && ordersList) {
//     ordersList.classList.remove("hidden");
//     if (wishlistContent) wishlistContent.classList.add("hidden");
//     if (accountUpdateForm) accountUpdateForm.classList.add("hidden");
//     updateMenuActiveState(firstMenuItem);
//   } else if (urlParams.has("wishlist") && wishlistContent) {
//     wishlistContent.classList.remove("hidden");
//     if (ordersList) ordersList.classList.add("hidden");
//     if (accountUpdateForm) accountUpdateForm.classList.add("hidden");
//     updateMenuActiveState(wishlistMenuItem);
//     renderWishlist(); // Ensure the wishlist is rendered when this section is displayed
//   } else if (accountUpdateForm) {
//     accountUpdateForm.classList.remove("hidden");
//     if (ordersList) ordersList.classList.add("hidden");
//     if (wishlistContent) wishlistContent.classList.add("hidden");
//     updateMenuActiveState(secondMenuItem);
//   }
//   const allWishlistButtons = document.querySelectorAll(".wishlist_button");
//   const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
//   allWishlistButtons.forEach((button) => {
//     const wishlistIcon = button.querySelector(".wishlist_icon");
//     if (wishlistIcon) {
//       const productId = wishlistIcon.getAttribute("data-product-id");
//       if (wishlist.some((product) => product.id === productId)) {
//         button.classList.add("active"); // Add active class if product is in the wishlist
//       } else {
//         button.classList.remove("active"); // Remove active class if product is not in the wishlist
//       }
//     }
//   });
// });

// colors
// const rangeSlider = document.getElementById("rangeSlider");
// const rangeValue = document.getElementById("rangeValue");
// function updateValue(e) {
//     e.preventDefault();
//     rangeValue.textContent = rangeSlider.value;

//     e.target.closest('.facets-wrap').querySelectorAll('ul.facets-layout li input').forEach((items)=>{
//       console.log( rangeSlider.value,items.getAttribute('value'));
//      if(items.getAttribute('value') === rangeSlider.value){
//        items.click()
//      }
//     })

// }

// rangeSlider.addEventListener("input", updateValue);

$(document).ready(function () {
  $("#rangeSlider").on("input", function (e) {
    e.preventDefault();
    let rangeValue = $(this).val();
    $("#rangeValue").text(rangeValue);
    $('ul[label="Dimensions"] li label').each(function () {
      let innervalue = $(this).find("input").attr("value");
      console.log(rangeValue, innervalue);
      if (innervalue === rangeValue) {
        $(this).click();
        $(this).addClass("activeee");
        console.log($(this), "$(this)");
      }
    });
  });
});
$("#overlay").click(function (params) {
  $(this).hide();
  $(".error_mesages").hide();
});
$(document).on("click", ".print_pdff", function () {
  printClonedDiv();
});
function printClonedDiv() {
  let originalDiv = document.getElementById("CartDrawer-CartItems");

  if (originalDiv) {
    // Clone the div
    let clonedDiv = originalDiv.cloneNode(true);
    clonedDiv.id = "clonedDiv"; // Change ID to avoid duplicates

    // Apply CSS styles
    clonedDiv.style.position = "absolute";
    clonedDiv.style.top = "20px";
    clonedDiv.style.left = "20px";
    clonedDiv.style.backgroundColor = "white";
    clonedDiv.style.padding = "20px";
    clonedDiv.style.border = "2px solid black";

    // Append cloned div to the body (temporarily)
    document.body.appendChild(clonedDiv);

    // Hide specific elements
    let elementsToHide = clonedDiv.querySelectorAll(
      ".cart-remove-button, .info_images, .cart-item__quantity, #CartDrawer-ColumnQuantity, #CartDrawer-LineItemStatus, thead, .cart-item__media"
    );
    elementsToHide.forEach((el) => (el.style.display = "none"));

    // Adjust image width for .info_images img
    let infoImages = clonedDiv.querySelectorAll(".info_image img");
    infoImages.forEach((img) => (img.style.width = "80px")); // Reduce image width

    // Align cart item image and price to the top
    let cartItems = clonedDiv.querySelectorAll(
      ".cart-item__media, .cart-item__totals"
    );
    cartItems.forEach((item) => {
      item.style.verticalAlign = "top";
      item.style.display = "block";
    });

    // Apply border-bottom to each <tr>
    let tableRows = clonedDiv.querySelectorAll("tbody tr");
    // tableRows.forEach(row => row.style.borderTop = "1px solid black");

    tableRows.forEach((row) => {
      row.style.borderTop = "1px solid black";
      row.style.paddingTop = "20px"; // Add padding to the top of each row
    });

    // Wait for images to load before printing
    let images = clonedDiv.getElementsByTagName("img");
    let loadedImages = 0;

    function checkAllImagesLoaded() {
      loadedImages++;
      if (loadedImages === images.length) {
        triggerPrint();
      }
    }

    if (images.length > 0) {
      for (let img of images) {
        if (img.complete) {
          checkAllImagesLoaded();
        } else {
          img.onload = checkAllImagesLoaded;
          img.onerror = checkAllImagesLoaded;
        }
      }
    } else {
      triggerPrint();
    }

    function triggerPrint() {
      let printWindow = window.open("", "", "width=600,height=600");
      printWindow.document.write(`
                <html>
                <head>
                    <title>Print</title>
                    <style>
                        @page { size: A4;  margin: 0mm; }
                        body { font-family: Arial, sans-serif; }
                        #clonedDiv { text-align: center; }
                        img { max-width: 100%; height: auto; }
                        .cart-remove-button, .info_images, .cart-item__quantity, #CartDrawer-ColumnQuantity, #CartDrawer-LineItemStatus, thead, .cart-item__media { display: none !important; }
                        .info_image img { width: 320px !important; } /* Reduce image width */
                        table { width: 100%; border-collapse: collapse; }
                        tbody tr { border-top: 1px solid black;padding-top: 10px !important } /* Adds a border after each row */
                        .cart-item__image, .cart-item__price { vertical-align: top !important; display: block !important; } /* Align to top */
                        th { text-align: center; } /* Center align the logo */
                        th img { width: 400px !important; display: block; margin: auto; } /* Set logo size */
                    </style>
                </head>
                <body>${clonedDiv.outerHTML}</body>
                </html>
            `);
      printWindow.document.close();
      printWindow.focus();

      setTimeout(() => {
        printWindow.print();
        printWindow.close();
        document.body.removeChild(clonedDiv); // Remove cloned div after printing
      }, 500);
    }
  }
}


   async function fetchWishlist() {
  try {
    const list = await SWishlist.getList(); // Fetch wishlist
    console.log(list.length);
    
    document.querySelectorAll('.wishlist-count').forEach(el => {
      el.innerText = list.length; // Update count in DOM
    });
    
  } catch (error) {
    console.error('Error fetching wishlist:', error);
  }
}

fetchWishlist();

    setInterval(fetchWishlist, 1000);